import { isArray } from 'lodash';
import { CustomViewRegister } from '../CustomView/registry';
import { GenericField } from '../DisplayValue';
import { WbBadge } from '../WbBadge';
import { WbComponentsListArray } from '../WbComponentsListArray';
import { CustomViewGridElement } from './utility';
import { useCustomViewNunjucksRenderer } from '../CustomView';

CustomViewRegister.register({
  id: 'badge',
  nunjucksPropsPaths: ['displayValue'],
  function: function Badge({
    value,
    displayValue,
    mode,
    label,
    colSpan,
  }: {
    value: any[] | any;
    displayValue?: string;
    mode?: string;
    label?: string;
    colSpan?: number;
  }) {
    let content;
    const nunjucksRenderer = useCustomViewNunjucksRenderer();

    if (isArray(value) && value.length > 0) {
      const badges = value
        .map((badge: any) => {
          const badgeDisplayValue = displayValue
            ? nunjucksRenderer.render(displayValue, badge) ?? ''
            : badge;
          return badgeDisplayValue;
        })
        .map(b => <WbBadge key={b as string}>{b}</WbBadge>);

      content = <WbComponentsListArray>{badges}</WbComponentsListArray>;
    } else if (value !== undefined)
      content = (
        <WbBadge>
          {displayValue
            ? nunjucksRenderer.render(displayValue, value) ?? ''
            : value}
        </WbBadge>
      );
    else content = <>-</>;

    if (mode === 'table') {
      return content;
    }

    return (
      <CustomViewGridElement colSpan={colSpan}>
        <GenericField label={label} value={content} />
      </CustomViewGridElement>
    );
  },
});
